import classnames from 'classnames';

const className = classnames('text-3xl', 'text-card-text-color', 'text-center');

interface Props {
  children: string;
}

const ErrorTitle = ({ children }: Props) => (
  <h3 className={className}>{children}</h3>
);

export default ErrorTitle;
